<template>
    <v-dialog v-model="dialog" width="600px" class="pa-0 ma-0">
        <v-card>
            <v-card-title class="justify-center">Ask the assistant a question</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <p class="text-center"> Ask "{{ conversation.metadata.assistant }}" a question</p>
                <p>This question is part of the concersation, the answer should refrect this.</p>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text class="py-2 px-5">
                <v-textarea v-model="question" rows="4" label="Ask a question" dense></v-textarea>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" small @click="submitQuestion()">Submit question</v-btn>
                <v-btn color="primary" small @click="closeDialog()">Cancel</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                conversation: {
                    metadata: {
                        assistant: "",
                    }
                },
                question: "",
            }
        },
        methods: { 
            openDialog(conversation) {
                this.conversation = conversation;
                this.question = "";
                this.dialog = true;
            },
            closeDialog() {
                this.dialog = false;
            },
            submitQuestion() {
                if (this.question === "") {
                    this.$store.dispatch("setSnackbar", {
                        showing: true,
                        text: "Question text must be given",
                        color: "error",
                    });  
                    return
                }
                this.$axios.post("ares/json/ares/syst/openai/submitQuestion.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "submitQuestion",
                    },
                    submitQuestion: {
                        conversation_id: this.conversation.id,
                        question: this.question,
                    }
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.submitQuestion.text,
                            color: res.data.submitQuestion.color,
                        });
                        this.$emit("updateData", "refresh");
                        this.closeDialog();
                    }
                });
            },
        }
    }
</script>
